import ArrowDown from '../../../visuals/Icons/ArrowDown';
import references from '../../../css-library/tokens/reference';
import { IconSizes } from '../../../visuals/Icons/type';

export const Arrow: React.FC = () => (
  <ArrowDown
    color={references.colors.blue[600]}
    size={IconSizes.sm}
    UNSAFE_className="tw-ml-1 tw-min-w-4"
    aria-hidden={true}
  />
);
